import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ScrollToTop from "../../ScrollToTop"

function ProductDetails() {
  const [myData, setMyData] = useState([]);
  const [isError, setIsError] = useState("");
  const [activeTab, setActiveTab] = useState("description");
  const [productName, setProductName] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // const location = useLocation();
  const { id } = useParams();
  const dataId = id;
 

  const getMyProductData = async () => {
    try {
      // console.log(id, "dataId");
      const response = await fetch("/db.json"); // Assuming db.json is in the public folder
      if (response.ok) {
        const data = await response.json();
        console.log("data",data.data, id)
        // const proName = data.posts.filter(
        //   (item) => item.id == dataId
        // );
        // setProductName(proName[0]['title'])
        // console.log(productName)
        const filteredData = data.data.filter(
          (item) => item.commentId == id
        );
        setMyData(filteredData);
        const proId = data.comments.filter(
          (item) => item.id == dataId
        );
        const proName = data.posts.filter(
          (item) => item.id == proId[0].postId
        );
        setProductName(proName[0]['title'])
        console.log(filteredData,'filteredData');
      } else {
        throw new Error("Error loading JSON data");
      }
    } catch (error) {
      setIsError(error.message);
    }
  };

  useEffect(() => {
    // getMyPoductData();
    getMyProductData();
  }, []);

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  return (
    <>
    <ScrollToTop />
      <div className="page-content">
        {/* Banner Area */}
        <div className="aon-page-benner-area2">
          <div className="aon-page-banner-row2">
            <div className="aon-page-benner-overlay2" />
            <div className="sf-banner-heading-wrap2">
              {/* <div className="sf-banner-heading-area2">
                <div className="sf-banner-breadcrumbs-nav2">
                  <ul className="list-inline">
                    <li>
                      <a href="/"> Home </a>
                    </li>
                    <li>Product Detail</li>
                  </ul>
                </div>
                <div className="sf-banner-heading-large2">Product Detail</div>
              </div> */}
              {/* <div className="sf-banner-vid-section">
                <div className="video-play-btn2">
                  <a
                    className="mfp-video"
                    href="https://www.youtube.com/watch?v=c1XNqw2gSbU"
                  >
                    <i className="fa fa-play" />
                  </a>
                  <span>
                    Watch Now <br />
                    Companey Details
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* Banner Area End */}
        {/* SECTION CONTENT START */}
        <div className="aon-innerpage-area">
          <div className="site-top-line" />
          {/* PRODUCT DETAILS */}
          <div className="container">
            <div className="row m-b30">
              <div className="col-lg-5 col-md-5  m-b30">
                <Carousel autoPlay>
                  {typeof myData[0]?.image === "string" ? (
                    <div className="aon-pro-full-media">
                      <img src={myData[0]?.image} alt="" />
                    </div>
                  ) : (
                    myData[0]?.image?.map((imageUrl, index) => (
                      <div className="aon-pro-full-media" key={index}>
                        <img src={'/'+imageUrl} alt="" />
                      </div>
                    ))
                  )}
                </Carousel>
              </div>
              <div className="col-lg-7 col-md-7">
                <div className="single-product-area">
                  <h3 className="single-product-title">{myData[0]?.title }</h3>
                  <div className="single-product-pricearea">
                    <div className="single-product-price">{productName}</div>
                    <div className="single-product-rating">
                      <span className="rating-bx2">
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                      </span>
                      {/* <span>(05 reviews)</span> */}
                    </div>
                  </div>
                  <div className="single-product-text">
                    {/* <p>
                      Nunc cursus imperdiet orci, eget hendrerit ante gravida
                      ut. Aenean non mauris orci. Mauris a magna id erat
                      fermentum euismod non ut lorem. Morbi neque mi, ultricies
                      sit amet vulputate.
                    </p> */}
                     {
                            myData[0]?.Function ?  <><p className="aon-shop2-text"> <b>Functions :</b> {myData[0]?.Function}</p> </> : null
                           }

                          {
                            myData[0]?.['Suitable For'] ?  <><p className="aon-shop2-text"> <b>Suitable For :</b> {myData[0]?.['Suitable For']}</p> </> : null
                           }
                           {
                            myData[0]?.['Efficacy'] ?  <><p className="aon-shop2-text"> <b>Efficiency :</b> {myData[0]?.['Efficacy']}</p> </> : null
                           }
                           {
                            myData[0]?.['Variety'] ?  <><p className="aon-shop2-text"> <b>Variety :</b> {myData[0]?.['Variety']}</p> </> : null
                           }
                  </div>
                  <div className="aon-list-check-style2">
                    <ul>
                      <li>
                        <i className="fa fa-check-circle" />
                        100% Organic Products
                      </li>
                      <li>
                        <i className="fa fa-check-circle" />
                        Recommended for {myData[0]?.['Suitable For']}
                      </li>
                      <li>
                        <i className="fa fa-check-circle" />
                        High Quality Cattle Feed
                      </li>
                    </ul>
                  </div>
                  <a className="aon-btn-cart m-b30" href="/contact">
                      <i className="fa fa-phone" />
                      Request for Call Back
                    </a>
                  {/* <form method="post" className="cart clearfix m-t30 " style={{marginLeft: '0px !important'}}>
                    <div className="single-product-qty">
                      <span>Choose Quantity:</span>
                      <div className="itm-Quantity-wrap">
                        <input
                          id="itm-Quantity"
                          type="text"
                          defaultValue={1}
                          name="itm-Quantity"
                        />
                      </div>
                    </div>
                    <div className="single-product-tag">
                      <span>Tag :</span> Agriculture, cattle farm, eco, eco farm
                    </div>
                    <button className="aon-btn-wishlist m-b30 m-r15">
                      <i className="fa fa-heart" />
                      Add to Wishlist
                    </button>
                    <button className="aon-btn-cart m-b30">
                      <i className="fa fa-shopping-basket" />
                      Add to Cart
                    </button>
                  </form> */}
                </div>
              </div>
            </div>
            {/* Detail SECTION START */}
            <ul
                className="nav nav-pills mb-3 aon-custom-nav aon-doctor-tabs"
                role="tablist"
              >
               
                <li className="nav-item" role="presentation">
                  <div
                    className={`nav-link active`}
                    onClick={() => handleTabClick("additionalInfo")}
                    role="tab"
                    aria-selected={activeTab === "additionalInfo"}
                  >
                    <h5 className="tb-title">Additional Info</h5>
                  </div>
                </li>
              </ul>
            <table className="table table--shaded">
                        <thead className="table__head">
                          <tr className="table__row">
                            <td className="table__cell table__cell--checkbox table__cell--no-wrap"></td>
                            <td className="UserTable__name table__cell table__cell--no-wrap">
                              Name
                            </td>
                            <td className="table__cell table__cell--remainder">
                              Description
                            </td>
                          </tr>
                        </thead>
                        <tbody className="table__body">
                        {myData && myData[0] ? Object.entries(myData[0]).map(([key, value]) => (
                            key != 'id' && key != 'title' && key != 'image' && key != 'commentId' ?
                                <tr key={key} className="table__row">
                                  <td className="table__cell table__cell--checkbox table__cell--no-wrap"></td>
                                  <td className="UserTable__name table__cell table__cell--no-wrap">
                                  {key.toLocaleUpperCase()}
                                  </td>
                                  <td className="table__cell table__cell--remainder">
                                  {value}
                                  </td>
                                </tr> : null
                              
                            )):null}
                  
               
                        
                        </tbody>
                      </table>
           
            {/* Detail SECTION END */}
          </div>
          {/* PRODUCT DETAILS */}
        </div>
        {/* CONTENT CONTENT END */}
        {/* SECTION CONTENT START */}
       
        {/* SECTION CONTENT END */}
        <section className="aon-add-area padding-top-0">
          <div className="container">
            <div className="section-content">
              <img src="images/add-one.png" alt="" />
            </div>
          </div>
          <div className="site-bot-line" />
        </section>
      </div>
    </>
  );
}

export default ProductDetails;
